import { FormInputBase } from './form-input-base';

export class RadioButton extends FormInputBase<string> {
  override controlType = 'radiobox';
}
